import { MasterHelper } from "../../utilities";

export class policyMappingData {
    id: number;
    updatesDB_Id: number;
    description: string;
    linkedDocuments: string;
    mappedRegulatoryText: string;
    constructor() {
        this.id = 0;
        this.updatesDB_Id = 0;
        this.description = '';
        this.linkedDocuments = '';
        this.mappedRegulatoryText = '';
    }
}

export class UpdateModel {
    updatesId: number;
    geography: string;
    country: string;
    regulator: string;
    pubDate: string;
    pubType: string;
    title: string;
    hyperlink: string;
    constructor() {
        this.updatesId = 0;
        this.geography = '';
        this.country = '';
        this.regulator = '';
        this.pubDate = '';
        this.pubType = '';
        this.title = '';
        this.hyperlink = '';
    }
}

export class DescriptionModel {
    Jurisdiction: string | null;
    User: string | null;
    Description: string;
    IsOriginal: boolean;
    constructor() {
        this.Jurisdiction = '';
        this.User = '';
        this.Description = '';
        this.IsOriginal = false;
    }
}

export class MatchPoliciesModel {
    updateModel: UpdateModel;
    descriptionModel: DescriptionModel[];
    linkedDocuments: string;
    similarityThreshold: number;
    constructor() {
        this.updateModel = new UpdateModel();
        this.descriptionModel = [];
        this.linkedDocuments = '';
        this.similarityThreshold = 0.0;
    }
}

export interface mappingPolicyModel {
    UpdatesDB_Id: number;
    policyName: string;
    policySection: string;
    policySubSection1: string;
    policySubSection2: string;
    policySubSection3: string;
    page_content: string;
    matchingUpdateDesc: string;
    relevance_score: number;
    relevance_score_str: string;
    meta_data: string;
}
export class MappedRegulatoryModel {
    suggestedName: string;
    Source: string;
    page: string;
    constructor() {
        this.suggestedName = '';
        this.Source = '';
        this.page = '';
    }
}
export class PolicyMappingCombinationModel {
    runNo: number;
    threshhold: number;
    descriptionsIds: number[];
    links: string[];
    constructor() {
        this.runNo = 0;
        this.threshhold = 0;
        this.descriptionsIds = [];
        this.links = [];
    }
}
export class GetMatchPoliciesInputModel {
    matchPoliciesModel: MatchPoliciesModel;
    combination:PolicyMappingCombinationModel;
    constructor() {
        this.matchPoliciesModel = new MatchPoliciesModel();
        this.combination = new PolicyMappingCombinationModel();
    }
}